// src/auth/config.ts
import awsconfig from '../../aws-exports';
// REPLACE THESE WITH YOUR ACTUAL VALUES
export const COGNITO_REGION = 'us-east-1'; 
export const COGNITO_USER_POOL_ID = 'us-east-1_XXXXXXXXX'; 
export const COGNITO_CLIENT_ID = awsconfig.client_id

// The JWKS URI for Cognito public keys
//export const JWKS_URI = `https://cognito-idp.${COGNITO_REGION}.amazonaws.com/${COGNITO_USER_POOL_ID}/.well-known/jwks.json`;
//export const JWKS_URI = `${awsconfig.authority}/.well-known/jwks.json`;

// The Cognito token endpoint for renewal
export const TOKEN_ENDPOINT = `https://<your-cognito-domain>/oauth2/token`;
// Or if you are using your custom backend endpoint
export const REFRESH_ENDPOINT = '/api/auth/refresh-token';